import { LineweightHeavy, LineweightLight, LineweightMedium } from '@air/next-icons';

import { type IconType } from '~/types/icons';

export const annotationSizes: { icon: IconType; width: number }[] = [
  { icon: LineweightLight, width: 1 },
  { icon: LineweightMedium, width: 3 },
  { icon: LineweightHeavy, width: 5 },
];
